// Third party dependencies.
import { StyleSheet } from 'react-native';

const styleSheet = StyleSheet.create({ imageStyle: { flex: 1 } });

export default styleSheet;
